(function () {
    $('body').on('click','.btn-layer-toggle',function(e){
        e.preventDefault();
        jQuery(this).toggleClass('active');
        jQuery(this).parent().toggleClass('reverse');
    });
})();